import React, {useState, useEffect} from 'react'
import { Link, useHistory } from "react-router-dom";
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import { 
  Progress,
  Button
} from 'reactstrap';

import MainLayout from '../layouts/MainLayout'
import ProfileFormContainer from '../components/ProfileForm';
import DropboxIntegrationContainer from '../components/DropboxIntegration';
import { useProfile } from '../api/hooks/profile';
import clsx from 'clsx';

import Logo from '../images/buho-avatar.png';


function ProfileCard({className, header, children}) {
  return (
    <div className={clsx("card", className)}>
      <div className="card-header">
        <h5 className="font-weight-bold mb-0">{header}</h5>
      </div>
      <div className="card-body">
        {children}
      </div>
    </div>
  )
}

function getSize(capacity) {
  const tb = capacity / 1000000;
  const gb = capacity / 1000;
  let amount;
  let type;
  if (tb > 1) {
    amount = tb;
    type = 'TB';
  } else if (gb > 1) {
    amount = gb;
    type = 'GB';
  } else {
    amount = capacity;
    type = 'MB';
  }
  return { amount, type }
}

function convertTo(capacity, type = 'MB') {
  let amount;
  if (type === 'TB') {
    amount = 1000000;
  } else if (type === 'GB') {
    amount = 1000;
  } else {
    amount = 1;
  }
  return { amount: +(capacity / amount) };
}

function ProfilePage(props) {
  const { t } = useTranslation('common');
  const { profile, isLoading } = useProfile();
  const [storage, setStorage] = useState({
    used: 0,
    total: 25,
    percentage: 0,
    type: 'MB'
  })
  

  useEffect(() => {
    const storageCapacity = getSize(profile?.storage?.total ?? 25);
    const storageUsed = convertTo(+profile?.storage?.used.toFixed(2) ?? 0, storageCapacity.type);
    const newPercentage = (storageUsed.amount / storageCapacity.amount * 100) ?? 0;
    setStorage({
      used: Math.max(storageUsed.amount, 0).toFixed(2),
      total: storageCapacity.amount,
      percentage: newPercentage,
      type: storageCapacity.type
    })
  }, [profile])


  return (
    <MainLayout paddingBottom={120}>
      <div className="container">
        <div className="row">
          <div className="col-lg-8">   
              <ProfileFormContainer />
          </div>
          <div className="col-lg-4">
            <div className="d-flex mb-3 justify-content-start">
              <Button tag={Link} to="/profile/subscriptions" color="accent-100" className="w-100">{t('subscription', { count: 2 })}</Button>
            </div>
            <ProfileCard header={t('storage')}>
              <div className="pb-3 d-flex flex-column justify-content-end">
                <strong className="pb-2">Trato Storage</strong>
                <Progress value={storage.percentage}>{storage.percentage} %</Progress>
                {!isLoading && 
                  <small className="align-self-end">
                    {t('storageUsed', { used: storage?.used, capacity: storage?.total, type: storage?.type })}
                  </small> 
                }
              </div>
             
              {/* <DropboxIntegrationContainer /> */}
            </ProfileCard>
            <ProfileCard className="mt-3" header={t('shield', { context: 'number', number: 1 })}>
                <p dangerouslySetInnerHTML={{ 
                  __html: t('youHaveArmorDocuments', { amount: Math.max(profile?.contracts?.remaining ?? 0, 0), armorType: t('shield', { context: 'number', number: 1 })})
                  }}
                />
                <Link to="/plans/one-time" className="animate-up mx-auto btn btn-accent">{t('buyMore')}</Link>
            </ProfileCard>
            <ProfileCard className="mt-3" header={t('shield', { context: 'number', number: 2 })}>
                <p dangerouslySetInnerHTML={{ 
                  __html: t('youHaveArmorDocuments', {amount: Math.max(profile?.nom151?.remaining ?? 0, 0), armorType: t('shield', { context: 'number', number: 2 })})
                  }}
                />
                <Link to="/plans/one-time" className="animate-up mx-auto btn btn-accent">{t('buyMore')}</Link>
            </ProfileCard>
            {/* <ProfileCard className="mt-3 mb-4" header={t('shield', { context: 'number', number: 3 })}>
                <p dangerouslySetInnerHTML={{ 
                  __html: t('youHaveArmorDocuments', {amount: Math.max(profile?.shield3?.remaining ?? 0, 0), armorType: t('shield', { context: 'number', number: 3 })})
                  }}
                />
                <Link to="/shop" className="animate-up mx-auto btn btn-accent">{t('buyMore')}</Link>
            </ProfileCard> */}
        </div>
        </div>
      </div>
    </MainLayout>
  )
}

ProfilePage.propTypes = {

}

export default ProfilePage

